<form [formGroup]="form" (ngSubmit)="emitValues()">
	<div class="form-control">
		<label class="label" for="role">Nome do Grupo</label>
		<input
			nbInput
			fullWidth
			type="text"
			name="role"
			formControlName="role"
			[status]="
				(controls.role.dirty && controls.role.invalid) || (submitted && controls.role.invalid)
					? 'danger'
					: 'basic'
			"
		/>
	</div>
	<h4>Permissão de Acesso</h4>
	<hr class="divider" />
	<div class="form-control">
		<h6>Visualizar</h6>
		<div class="row">
			<div class="col-auto mb-2">
				<nb-checkbox (checkedChange)="toggle($event, 'view', 'all')">Selecionar Todos</nb-checkbox>
			</div>
			<div class="col-auto mb-2" *ngFor="let module of modulesGrouped.view">
				<nb-checkbox (checkedChange)="toggle($event, 'view', module.key)" [checked]="module.checked">{{
					module.label
				}}</nb-checkbox>
			</div>
		</div>
	</div>
	<div class="form-control">
		<h6>Criar/Editar</h6>
		<div class="row">
			<div class="col-auto mb-2">
				<nb-checkbox (checkedChange)="toggle($event, 'create', 'all')">Selecionar Todos</nb-checkbox>
			</div>
			<div class="col-auto mb-2" *ngFor="let module of modulesGrouped.create">
				<nb-checkbox (checkedChange)="toggle($event, 'create', module.key)" [checked]="module.checked">{{
					module.label
				}}</nb-checkbox>
			</div>
		</div>
	</div>
	<div class="form-control">
		<h6>Deletar</h6>
		<div class="row">
			<div class="col-auto mb-2">
				<nb-checkbox (checkedChange)="toggle($event, 'delete', 'all')">Selecionar Todos</nb-checkbox>
			</div>
			<div class="col-auto mb-2" *ngFor="let module of modulesGrouped.delete">
				<nb-checkbox (checkedChange)="toggle($event, 'delete', module.key)" [checked]="module.checked">{{
					module.label
				}}</nb-checkbox>
			</div>
		</div>
	</div>
	<div class="row justify-content-center mt-5 mb-3">
		<div class="col-md-4">
			<button nbButton outline fullWidth status="danger" (click)="clearForm()">Limpar</button>
		</div>
		<div class="col-md-4">
			<button nbButton outline fullWidth status="info" type="submit">Criar</button>
		</div>
	</div>
</form>
